import { useTheme, Box } from "@mui/material";

const DataRow = ({
  index,
  hoveredIndex,
  setHoveredIndex,
  children,
  onMouseEnter = null,
  onMouseLeave = null,
  style = {},
  ...props
}) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 1,
        fontSize: "1rem",
        borderBottom: "1px solid grey",
        ...(hoveredIndex === index + 1 ? { borderBottom: "none" } : {}),
        pb: 2,
        pt: index === 0 ? 0 : 2,
        cursor: "pointer",
        "&:hover": {
          borderRadius: "12px",
          borderBottom: "none",
          border: theme.palette.tinyBorder,
          px: 1,
          py: 2,
          backgroundColor: theme.palette.action.hover,
          boxShadow: theme.palette.squareBoxShadow,
        },
        transition: "all 0.3s ease",
        ...style,
      }}
      onMouseEnter={() => {
        setHoveredIndex(index);
        if (onMouseEnter) onMouseEnter();
      }}
      onMouseLeave={() => {
        setHoveredIndex(null);
        if (onMouseLeave) onMouseLeave();
      }}
      className="data-row"
      {...props}
    >
      {children}
    </Box>
  );
};

export default DataRow;
